/**
 * Navegación compartida por el Sidebar (desktop) y la MobileTabBar (móvil).
 */
import {
  BarChart3,
  Building2,
  Calendar,
  DollarSign,
  Leaf,
  Package,
  RotateCcw,
  ShoppingCart,
  Terminal,
  Users,
} from 'lucide-react'

export const MENU = [
  { to: '/', label: 'Dashboard', icon: Calendar, roles: ['superadmin', 'sales', 'restricted'], end: true },
  { to: '/sales', label: 'Ventas', icon: DollarSign, roles: ['superadmin', 'sales', 'user'] },
  { to: '/returns', label: 'Devoluciones', icon: RotateCcw, roles: ['superadmin', 'sales', 'user'] },
  { to: '/purchases', label: 'Compras', icon: ShoppingCart, roles: ['superadmin'] },
  { to: '/clients', label: 'Clientes', icon: Users, roles: ['superadmin', 'sales'] },
  { to: '/partners', label: 'Partners', icon: Building2, roles: ['superadmin'] },
  { to: '/inventory', label: 'Inventario', icon: Package, roles: ['superadmin'] },
  { to: '/products', label: 'Producto', icon: Leaf, roles: ['superadmin'] },
  { to: '/reports', label: 'Reportes', icon: BarChart3, roles: ['superadmin'] },
]

// Módulo de desarrollo: visible cuando el backend reporta dev mode.
export const DEV_ITEM = { to: '/dev', label: 'Dev Tools', icon: Terminal, roles: ['superadmin'] }

/** Items visibles para un rol (incluye Dev si está habilitado). */
export function navItemsFor(role, devEnabled) {
  const menu = devEnabled ? [...MENU, DEV_ITEM] : MENU
  return menu.filter((m) => m.roles.includes(role))
}
